import { Check } from "lucide-react";

const usd = (n) => (n >= 1e6 ? `$${(n / 1e6).toFixed(1)}m` : `$${Math.round(n || 0).toLocaleString()}`);

/**
 * Facilities as labelled cards you click, not a dropdown you guess at: what it is, what it is for, the land
 * it needs and what it costs to build, with the chosen one plainly marked.
 */
export const FacilityPicker = ({ facilities = [], value, onChange, testId = "facility-picker" }) => {
  if (!facilities.length) return null;
  return (
    <div className="grid gap-px sm:grid-cols-2 lg:grid-cols-3" data-testid={testId}>
      {facilities.map((f) => {
        const on = f.id === value;
        return (
          <button
            key={f.id}
            type="button"
            onClick={() => onChange(f.id)}
            aria-pressed={on}
            data-testid={`facility-option-${f.id}`}
            data-selected={on ? "true" : "false"}
            className={`flex h-full flex-col gap-3 border border-zinc-900 p-6 text-left transition-colors ${
              on ? "border-ochre bg-[#161208]" : "bg-[#0b0b0b] hover:bg-[#121212]"
            }`}
          >
            <span className="flex items-start justify-between gap-3">
              <span className={`mono text-[0.55rem] uppercase tracking-[0.16em] ${on ? "text-ochre" : "text-zinc-500"}`}>
                {f.tier_label}
              </span>
              {on ? (
                <span className="mono inline-flex items-center gap-1 bg-ochre px-2 py-0.5 text-[0.5rem] uppercase tracking-[0.16em] text-black"
                  data-testid={`facility-selected-${f.id}`}>
                  <Check size={10} /> Selected
                </span>
              ) : (
                <span className="mono text-[0.5rem] uppercase tracking-[0.16em] text-zinc-600">Select</span>
              )}
            </span>

            <span className="font-display text-base uppercase leading-tight text-white md:text-lg">{f.name}</span>
            <span className="text-xs leading-relaxed text-zinc-400">{f.purpose}</span>

            <span className="mono mt-auto grid gap-1.5 border-t border-zinc-800 pt-3 text-[0.55rem] uppercase tracking-[0.14em] text-zinc-500">
              <span>{f.pitch_summary}</span>
              <span>Land: {f.land_acres} acres · {Math.round(f.land_m2).toLocaleString()} m²</span>
              <span className={on ? "text-ochre" : "text-zinc-400"}>Build from {usd(f.clubhouse_usd)} · indicative</span>
            </span>
          </button>
        );
      })}
    </div>
  );
};
